module.exports = __webpack_public_path__ + "img/5.50c66b15.png";